<template>
  <ImageView
    :image="mainImage"
    :type="type"
    :height="height"
    :width="width"
  />
</template>

<script>
import ImageView from './ImageView'

export default {
  name: 'MainImageViewer',
  components: { ImageView },
  props: {
    images: {
      type: Array,
      default () {
        return []
      },
    },
    type: {
      type: String,
      default () {
        return 'full'
      },
    },
    height: {
      type: String,
      default () {
        return '60px'
      },
    },
    width: {
      type: String,
      default () {
        return '60px'
      },
    },
  },
  computed: {
    mainImage () {
      if (this.images && this.images.length > 0) {
        const mainImages = this.images.filter(img => img.is_main)
        if (mainImages.length >= 1)
          return mainImages[0]
        else
          return this.images[0]
      }
      return null
    },
  },
}
</script>

<style scoped>

</style>
